import { render } from "./ParticipantDashboard.vue?vue&type=template&id=4d623216&ts=true"
import script from "./ParticipantDashboard.vue?vue&type=script&lang=ts"
export * from "./ParticipantDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__